exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset[data-v-1b4fa63e]{margin-bottom:30px}fieldset.open .header[data-v-1b4fa63e]{border-radius:0}fieldset>header[data-v-1b4fa63e]{border-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0;height:50px;cursor:pointer;display:flex;align-items:center;padding:0 10px;background:#f1f2f5;color:#222;font-size:14px;font-weight:600;width:100%;-webkit-user-select:none;-moz-user-select:none;user-select:none}fieldset>section[data-v-1b4fa63e]{padding:20px;width:100%;background:#fff;border:1px solid #f1f2f5}fieldset .row[data-v-1b4fa63e]{margin-bottom:20px}fieldset .row[data-v-1b4fa63e]:last-of-type{margin-bottom:0}", ""]);

// exports
